export default __webpack_public_path__ + "files/483f4bec50d7c358633e0cabca528689.svg";